import React, { useEffect, useState } from "react";
import PageLayout from "../layouts/MainLayout";
import NOPtable from "../components/Regulatory/NOPtable";

const NoticesOrders = () => {
  return (
    <PageLayout
      home={false}
      pageHeader={
        <>
          Recent Registrar's Actions
        </>
      }
    >
      <NOPtable />
    </PageLayout>
  )
}

export default NoticesOrders;
